module.exports = __webpack_public_path__ + "assets/places_white.3d829f36.svg";